"use client";

import { createContext, useContext } from "react";

export type RuntimeConfig = {
  uatMode: boolean;
  realtime: {
    enabled: boolean;
    siteName: string;
  };
};

/** What the root layout serialises into every page's RSC payload. Only
    settings that are switched on are sent, so a production page carries no
    environment flags or socket site name
    (DAST-F360-005). Expanded to RuntimeConfig in the browser. */
export type PublicRuntimeConfig = {
  uatMode?: true;
  realtime?: { siteName: string };
};

export function expandRuntimeConfig(config: PublicRuntimeConfig): RuntimeConfig {
  return {
    uatMode: config.uatMode === true,
    realtime: { enabled: Boolean(config.realtime), siteName: config.realtime?.siteName ?? "" },
  };
}

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({ config, children }: { config: RuntimeConfig; children: React.ReactNode }) {
  return <RuntimeConfigContext.Provider value={config}>{children}</RuntimeConfigContext.Provider>;
}

export function useRuntimeConfig() {
  const config = useContext(RuntimeConfigContext);
  if (!config) throw new Error("useRuntimeConfig must be used inside RuntimeConfigProvider");
  return config;
}
